import { Box, FlexProps, HStack, StackProps, Text } from '@chakra-ui/react';
import React from 'react';
import { OptionType } from '~/types';
import { formatPercentage } from '~/utils';

import { GENDERS, GenderLabel } from './components/GenderLabel';

interface Props extends FlexProps {
  overallGenderDistribution: OptionType<number>[];
  title?: string;
  stackProps?: StackProps;
}

export const GenderDistribution: React.FC<Props> = ({
  overallGenderDistribution = [] as OptionType<number>[],
  title,
  stackProps,
  ...props
}) => {
  const female =
    overallGenderDistribution.find(
      (femaleData) => femaleData.label.toLowerCase() === GENDERS.Female,
    ) || ({ label: GENDERS.Female, value: NaN } as OptionType<number>);

  const male =
    overallGenderDistribution.find(
      (maleData) => maleData.label.toLowerCase() === GENDERS.Male,
    ) || ({ label: GENDERS.Male, value: NaN } as OptionType<number>);
  const genders = [female, male];

  return (
    <Box {...props} data-testid="gender-distribution-section">
      {title && (
        <Text
          fontSize="md"
          fontWeight="medium"
          textTransform="uppercase"
          lineHeight="14px"
          letterSpacing="wide"
        >
          {title}
        </Text>
      )}
      <HStack marginTop={4} spacing={8} {...stackProps}>
        {genders?.map((gender) => (
          <GenderLabel
            gender={gender.label.toLowerCase() as GENDERS}
            value={formatPercentage(gender.value, undefined, 1)}
            key={`gender-${gender.label}`}
          />
        ))}
      </HStack>
    </Box>
  );
};
